import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule, MatIconButton } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatDialog } from "@angular/material/dialog";
import { OverlayModule } from "@angular/cdk/overlay";
import { OrganizationsFilterService } from '../../../services/organizations/organizations-filter.service.js';
import { OrganizationsService } from '../../../services/organizations/organizations.service.js';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';

/** Controls for the organizations list page. This contains controlling search, provider, and date filters */
@Component({
	selector: 'app-organizations-filter',
	imports: [
		MatInputModule,
		MatButtonModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		OverlayModule,
		MatPaginatorModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './organizations-controls.component.html',
	styleUrl: './organizations-controls.component.scss'
})
export class OrganizationsControls implements OnInit {

	/** global search */
	globalSearch: FormControl<string>;

	/** The search control on the page */
	searchControl = new FormControl<string>('');

	/** Is the search feature hidden or shown? */
	isSearchOpen: boolean = false;

	/** Dispatched when the search filter changes */
	@Output()
	readonly searchChange = new EventEmitter<string>();

	@ViewChild(MatPaginator)
	private paginator: MatPaginator;

	constructor(private organizationsService: OrganizationsService,
		private organizationsFilterService: OrganizationsFilterService,
		private matDialog: MatDialog) {
	}

	ngOnInit(): void {

		this.globalSearch = new FormControl<string>('');

		this.searchControl.valueChanges.subscribe(value => this.searchChange.emit(value));
	}

	/** Reset the search filter */
	resetSearch() {
		this.searchControl.setValue('');
		this.searchChange.emit(this.searchControl.value);
	}

	onPageChange(event: PageEvent) {
		this.organizationsFilterService.pageEvent = event;
	}

	setTotal(total: number) {
		this.paginator.length = total;
	}

	async onEnterKey() {
		if(!this.globalSearch.getRawValue()) {
			this.organizationsFilterService.globalSearch = this.globalSearch.getRawValue();
		}
	}
	async clickGlobalSearchX(event: MouseEvent) {
		if((event as PointerEvent).pointerId > 0) {
			this.globalSearch.reset(null);
			this.organizationsFilterService.globalSearch = this.globalSearch.getRawValue();
		} else {
			this.organizationsFilterService.globalSearch = this.globalSearch.getRawValue();
		}
	}
}
